export default __webpack_public_path__ + "static/media/grafico_flujo.324cfbe6.png";